module.exports = __webpack_public_path__ + "2e90d5152ce92858b62ba053c7b9d2cb.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Bold-webfont.woff
// module id = 1146
// module chunks = 0